import { getOutputs, editOutput } from '@/api'
//
export default {
	namespaced: true,

	state: {
		outputs: []
	},

	mutations: {
		setOutputs (state, outputs) {
			state.outputs = outputs
		}
	},

	actions: {
		getOutputs (store) {
			return getOutputs()
				.then(response => {
					store.commit('setOutputs', response.data.result)
				})
		},

		editOutput (store, outputs) {
			return editOutput(outputs._id, outputs)
				.then(response => {
					store.dispatch('getOutputs')
				})
		}
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/outputs.js